// src/pages/Leaderboard.jsx
import React from "react";

function Leaderboard() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-3xl font-bold">Leaderboard</h1>
      <p className="text-gray-700 mt-2">View trusted influencers here.</p>
    </div>
  );
}

export default Leaderboard;
